import React, { ReactNode, useEffect, useState } from 'react';
import { TabsContainer } from './Tabs.styles';
import TabComponent from './TabComponent';

export interface Tab {
  icon?: ReactNode;
  title: string;
  onClick: () => void;
  disabled?: boolean;
  className?: string;
}

export interface TabsProps {
  tabs: Tab[];
  variant?: 'compact' | 'medium' | 'large';
  className?: string;
  withUnderline?: boolean;
  defaultActiveTab?: number;
  fullUnderline?: boolean;
  type?: 'default' | 'accent-primary';
}

const Tabs = ({
  tabs,
  variant = 'medium',
  className,
  withUnderline = true,
  fullUnderline = true,
  defaultActiveTab = 0,
  type = 'default',
}: TabsProps) => {
  const [activeTab, setActiveTab] = useState(defaultActiveTab);

  const handleTabClick = (tab: Tab, index: number) => {
    tab.onClick();
    setActiveTab(index);
  };

  useEffect(() => {
    setActiveTab(defaultActiveTab);
  }, [defaultActiveTab]);

  return (
    <TabsContainer className={className}>
      {tabs.map((tab, index) => (
        <TabComponent
          key={index}
          variant={variant}
          title={tab.title}
          icon={tab.icon}
          disabled={tab.disabled}
          onClick={() => handleTabClick(tab, index)}
          active={index === activeTab}
          withUnderline={withUnderline}
          className={tab.className}
          type={type}
        />
      ))}
      {withUnderline && fullUnderline && (
        <div className="grow border-b-2 border-stroke-base-default" />
      )}
    </TabsContainer>
  );
};

export default Tabs;
